import { render, staticRenderFns } from "./PrivateInfoBancaire.vue?vue&type=template&id=58298fe6&scoped=true&"
import script from "./PrivateInfoBancaire.vue?vue&type=script&lang=js&"
export * from "./PrivateInfoBancaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58298fe6",
  null
  
)

export default component.exports